export default defineNuxtPlugin(() => {
    const nuxtApp = useNuxtApp()
    const customTranslations = useState('customTranslations')
    const getActiveLocale = (locale = nuxtApp.$i18n.locale.value) =>
        ['no-such-locale', ...nuxtApp.$conf.public.locales].includes(locale) ? locale : nuxtApp.$conf.public.locales[0]
    const locale = getActiveLocale()
    nuxtApp.$axios.setHeader('Accept-Language', locale)

    nuxtApp.$i18n.onBeforeLanguageSwitch = async (oldLocale, newLocale) => {
        const locale = getActiveLocale(newLocale)
        if (import.meta.server) {
            try {
                customTranslations.value = await $fetch(
                    `${nuxtApp.$conf.public.host}${nuxtApp.$conf.public.routerBase || '/'}cms/custom-translations`
                )
            } catch (e) {
                console.error(e)
            }
            if (customTranslations.value[locale]) {
                nuxtApp.$i18n.mergeLocaleMessage(locale, customTranslations.value[locale])
            }
        }
        nuxtApp.$axios.setHeader('Accept-Language', locale)
        nuxtApp.$vuetify.locale.current.value = locale
        return locale
    }

    // called right after a new locale has been set
    nuxtApp.hook('i18n:localeSwitched', async ({newLocale}) => {
        if (customTranslations.value[newLocale]) {
            nuxtApp.$i18n.mergeLocaleMessage(newLocale, customTranslations.value[newLocale])
        }
    })
})
